import {
   UserAttendance,
   UserAttendanceStatus,
   UserModel
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { useUserAppConfigStore } from './stores/useUserAppConfigStore'

interface UserObjType {
   attendance?: UserAttendance | null
}

type UserAttendanceStatusHookReturnType = {
   getAttendanceStatus: (userModel: UserModel) => UserAttendanceStatus | null
   getAttendanceStatusFromObj: (
      userObj: UserObjType
   ) => UserAttendanceStatus | null
}

const useUserAttendanceStatus = (): UserAttendanceStatusHookReturnType => {
   const userAppConfigStore = useUserAppConfigStore()

   const { isAttendanceTrackingEnabled } = userAppConfigStore.permissions

   const getAttendanceStatus = (
      userModel: UserModel
   ): UserAttendanceStatus | null => {
      if (!isAttendanceTrackingEnabled) return null

      const reult = userModel.attendance?.clockIn
         ? UserAttendanceStatus.Online
         : UserAttendanceStatus.Offline

      return reult
   }

   const getAttendanceStatusFromObj = (
      userObj: UserObjType
   ): UserAttendanceStatus | null => {
      if (!isAttendanceTrackingEnabled) return null

      const result = userObj.attendance?.clockIn
         ? UserAttendanceStatus.Online
         : UserAttendanceStatus.Offline

      return result
   }

   return {
      getAttendanceStatus,
      getAttendanceStatusFromObj
   }
}

export default useUserAttendanceStatus
